export enum AppActionType {}

export enum CalculatorActionType {
  NEXT_STEP = 'CALCULATOR_NEXT_STEP',
  PREV_STEP = 'CALCULATOR_PREV_STEP',
  JUMP_TO_STEP = 'JUMP_TO_STEP',
  VIEW_3D = 'VIEW_3D',
  SET_METRIC_SYSTEM = 'SET_METRIC_SYSTEM',

  SET_UNIT_PACKAGING = 'SET_UNIT_PACKAGING',
  SET_DIMENSIONS = 'SET_DIMENSION',
  SET_WEIGHT = 'SET_WEIGHT',

  SET_PALLET_DATA = 'SET_PALLET_DATA',

  LAYER_SET_ACTIVE_PATTERN = 'LAYER_SET_ACTIVE_PATTERN',
  LAYER_SET_PATTERN_TYPE = 'LAYER_SET_PATTERN_TYPE',
  LAYER_SET_UNITS = 'LAYER_SET_UNITS',
  SET_LAYER_CONFIG_TYPE = 'SET_LAYER_CONFIG_TYPE',
  LAYER_SET_HORIZONTAL_OVERLAP = 'LAYER_SET_HORIZONTAL_OVERLAP',
  LAYER_SET_VERTICAL_OVERLAP = 'LAYER_SET_VERTICAL_OVERLAP',

  SET_LOAD_HEIGHT = 'SET_LOAD_HEIGHT',

  SET_RESULTS_UNIT_SYSTEM = 'SET_RESULTS_UNIT_SYSTEM',
  /* Save images in the state to use them in the PDF */
  SET_2D_IMAGE = 'SET_2D_IMAGE',
  SET_3D_IMAGE = 'SET_3D_IMAGE',

  SET_LAYER_ALIGNMENT_ITEM = 'SET_LAYER_ALIGNMENT_ITEM',
}

export enum CalculatorStep {
  UNIT_INFORMATION = 'UNIT_INFORMATION',
  PALLET_DATA = 'PALLET_DATA',
  LAYER_CONFIGURATION = 'LAYER_CONFIGURATION',
  LAYER_ALIGNMENT = 'LAYER_ALIGNMENT',
  RESULTS = 'RESULTS',
}

export enum CalculatorStepState {
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
}

export enum UnitPackaging {
  BOX = 'Box',
  BAG = 'Bag',
  OVERLAP_BAG = 'Overlap Bag',
}

export enum UnitDimension {
  MM = 'MM',
  INCH = 'INCH',
}

export enum UnitWeight {
  KG = 'KG',
  LBS = 'LBS',
}

export enum PalletType {
  PALLET_40x48 = '48x40 inch',
  PALLET_40x54 = '54x40 inch',
  INDUSTRIE = '1200x1000 mm',
  EUROPALLET = '1200x800 mm',
  CUSTOM = 'Custom',
}

export enum LayerPatternType {
  ALIGNED = 'ALIGNED',
  OVERHANG = 'OVERHANG',
}

export enum LoadHeightType {
  HEIGHT = 'Height',
  LAYERS = '#Layers',
}

export enum LayerConfiguration {
  AUTO = 'Auto',
  MANUAL = 'Manual',
}

export enum ResultsUnitSystem {
  METRIC = 'Metric',
  IMPERIAL = 'Imperial',
}

export enum LayerAlignmentType {
  H_MIRRORED = 'H_MIRRORED',
  V_MIRRORED = 'V_MIRRORED',
  ROTATED = 'ROTATED',
  PARALLEL = 'PARALLEL',
}
